module.exports = __webpack_public_path__ + "img/9788932911014.4fdb1033.jpg";